export enum ChargingSpeed {
  Normal = 'Normal',
  Fast = 'Fast',
  Super = 'Super',
}
